import Radium from "radium";
import { connect } from "react-redux";

import ResetPassword, { IResetPasswordActions } from "./reset-password";
import { navigateTo } from "../../home";
import { resetPassword } from "../user.actions";

export default connect(
  null,
  (dispatch): IResetPasswordActions => ({
    navigateToLogin: () => dispatch(navigateTo("/")),
    resetPassword: (userName: string) => {
      dispatch(resetPassword(userName));
    }
  })
)(Radium(ResetPassword));
